module.exports = __webpack_public_path__ + "img/media-line-bottom.5ed49529.svg";